
import { defineComponent } from 'vue';
import Markdown from '../Markdown.vue';

const __default__ = defineComponent({
  components: {
    Markdown,
  },
  props: {
    message: {
      type: Object,
      required: true,
    },
    aiName: {
      type: String,
      required: true,
    },
    aiColor: {
      type: String,
      default: '#3450a3',
    },
    isStreaming: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    chatResponseClasses(): Array<string> {
      const classes = [
        'ai-chat-response',
        `ai-chat-${this.message.role}-response`,
      ];
      if (this.isStreaming) {
        classes.push('ai-chat-streaming');
      }
      return classes;
    },
  },
});

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "177140e2": (_ctx.aiColor)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__